import { render, staticRenderFns } from "./OrderPurcharseServed.vue?vue&type=template&id=68e16ed8&"
import script from "./OrderPurcharseServed.vue?vue&type=script&lang=js&"
export * from "./OrderPurcharseServed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports